<template>
  <v-app>
    <v-main>
      <v-app-bar
        v-if="$vuetify.breakpoint.mobile"
        dense
        fixed
        color="rgba(255, 255, 255, 0.5)"
      >
        <!-- <v-img
          src="../public/static/sr400el-logo.png"
          class="shrink mr-2"
          width="110"
          contain
        /> -->
        <v-spacer></v-spacer>
        <HelpText
          v-if="$vuetify.breakpoint.mobile"
          :slide-title="slideTitle"
          :help-text="helpText"
          :about-text="aboutText"
          :show-help-text="showHelpText"
          :show-about-text="showAboutText"
          :show-reminder-modal="showReminderModal"
          :toggle-help-text="toggleHelpText"
          :toggle-about-text="toggleAboutText"
        />
    
        <v-app-bar-nav-icon @click="menu = true"></v-app-bar-nav-icon>
      </v-app-bar>
      <v-menu
        v-model="menu"
        min-width="50%"
        :position-x="1000"
        transition="scroll-y-transition"
        max-height="100vh"
      >
        <v-list dense nav>
          <v-list-item-group v-model="workShopSlide" color="primary" mandatory>
            <v-list-item
              v-for="(page, index) in slideLabels"
              :key="page"
              link
              @click="goToSlide(index)"
            >
              <v-list-item-content class="text-center">
                <v-list-item-title v-html="page"> </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-row>
        <v-col
          :cols="$vuetify.breakpoint.mobile ? `12` : `10`"
          style="overflow:hidden; padding: 0%"
        >
          <Workshop
            :work-shop-slide="workShopSlide"
            :help-text="helpText"
            :about-text="aboutText"
            :slide-title="slideTitle"
            :show-help-text="showHelpText"
            :show-about-text="showAboutText"
            :show-reminder-modal="showReminderModal"
            :slide-visited="slideVisited"
            :get-slide-title="getSlideTitle"
            :get-slide-help-text="getSlideHelpText"
            :get-slide-about-text="getSlideAboutText"
            :toggle-help-text="toggleHelpText"
            :toggle-about-text="toggleAboutText"
            @update-slide="goToSlide"
          />
        </v-col>
        <v-col
          cols="2"
          v-if="!$vuetify.breakpoint.mobile"
          style="padding: 0% !important;"
        >
          <v-navigation-drawer
            right
            permanent
            color="rgba(255, 255, 255, 0.1)"
            width="100%"
          >
            <v-list dense nav>
              <v-list-item-group
                v-model="workShopSlide"
                color="primary"
                mandatory
              >
                <v-list-item
                  v-for="(page, index) in slideLabels"
                  :key="page"
                  link
                  @click="goToSlide(index)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="[
                        $vuetify.breakpoint.mdAndUp ? 'text-h4' : 'body-1'
                      ]"
                      v-html="page"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-content
                  :style="{
                    'padding-top': $vuetify.breakpoint.mobile ? `0%` : `15%`
                  }"
                  :class="{ logos: !$vuetify.breakpoint.mobile }"
                >
                  <v-img
                    src="../public/static/logo_GDOT.png"
                    :class="{ logoMobile: $vuetify.breakpoint.mobile }"
                  />
                </v-list-item-content>
                <!-- <v-list-item-content class="logos">
                  <v-img
                    src="../public/static/sr400el-logo.png"
                    :class="{ logoMobile: $vuetify.breakpoint.mobile }"
                  />
                </v-list-item-content> -->
                <!-- <v-list-item-content class="logos">
                  <v-img
                    src="../public/static/peach-pass-logo-2016.png"
                    :class="{ logoMobile: $vuetify.breakpoint.mobile }"
                  />
                </v-list-item-content> -->
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import Workshop from "./components/Workshop.vue";
import HelpText from "@/components/HelpText.vue";

export default {
  name: "App",

  components: {
    Workshop,
    HelpText
  },
  props: {
    aboutIcon: {
      type: String,
      default: "mdi-account-question"
    },
    helpIcon: {
      type: String,
      default: "mdi-information"
    }
  },
  data: () => ({
    workShopSlide: 0,
    slideLabels: [
      // "Welcome",
      "Virgil Langford",
      "Oconee Connector",
      // "Detour*",
      "Environmental",
      "Property Acquisitions",
      // "Comment Station"
    ],
    menu: false,
    slideTitle: "",
    helpText: "",
    aboutText: "",
    showHelpText: true,
    showAboutText: false,
    onCommentStationSlide: false,
    showCommentReminder: false,
    onExecutiveSummarySlide: false,
    showReminderModal: false,
    // slideVisited: [0]
    slideVisited: [0, 0, 0, 0]
  }),
  mounted() {
    this.getSlideTitle();
    this.getSlideHelpText();
    this.getSlideAboutText();
    this.slideVisited[this.workShopSlide] = 1;
  },
  watch: {
    workShopSlide() {
      this.getSlideTitle();
      this.getSlideHelpText();
      this.getSlideAboutText();
      this.$gtag.pageview({
        page_path: this.workShopSlide
      });
      if (!this.slideVisited[this.workShopSlide]) {
        this.showHelpText = true;
        this.slideVisited[this.workShopSlide] = 1;
      }
    }
  },
  methods: {
    goToSlide(slide) {
      this.workShopSlide = slide;
      // if (this.slideTitle === "Executive Summary") {
      //   this.showReminderModal = true
      // }
    },
    hoverAction(slide) {
      console.log('hovered slide: ', slide)
    },
    async getSlideHelpText() {
      const svg = await import(`@/data/slide${this.workShopSlide + 1}`);
      this.helpText = svg.default.helpText;
    },
    async getSlideAboutText() {
      const svg = await import(`@/data/slide${this.workShopSlide + 1}`);
      this.aboutText = svg.default.aboutText;
    },
    async getSlideTitle() {
      const svg = await import(`@/data/slide${this.workShopSlide + 1}`);
      this.slideTitle = svg.default.slideTitle;
    },
    toggleHelpText() {
      this.showHelpText = !this.showHelpText;
      this.showReminderModal = false
    },
    toggleAboutText() {
      this.showAboutText = !this.showAboutText;
      this.showReminderModal = false
    },
    toggleReminderModal() {
      debugger
      this.showReminderModal = false
    }
  }
};
</script>
<style scoped>
.logos {
  padding-left: 10%;
  padding-right: 10%;
}
.logoMobile {
  padding-left: 0;
  margin-left: -5%;
  margin-top: -5%;
  margin-bottom: -12%;
}

</style>
